import { render, staticRenderFns } from "./aiFactory.vue?vue&type=template&id=bc81e022&scoped=true"
import script from "./aiFactory.vue?vue&type=script&lang=js"
export * from "./aiFactory.vue?vue&type=script&lang=js"
import style0 from "./aiFactory.vue?vue&type=style&index=0&id=bc81e022&prod&lang=scss&scoped=true"
import style1 from "./aiFactory.vue?vue&type=style&index=1&id=bc81e022&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc81e022",
  null
  
)

export default component.exports